import React from 'react';
import { useTranslation } from 'react-i18next';
import PasswordValidator from './common/passwordValidator';
import LinkExpired from './linkExpired';
import { isLargeDesktop, isMobile } from '../commonUtil/responsiveUtil';
import { PasswordSource, ValidationErrorCode } from '../commonUtil/constants';
import { withLinkStore } from '../app/reducers';
import ViewerPanel from './viewerPanel';
import { getCompliancePwdCookie } from '../commonUtil/cookieUtil';
import CustomFooter from './customFooter';
import { setNewrelicCustomAttribute, executeNewrelicTracerForOthers } from '../commonUtil/newrelicTracer';

const CompliancePage = (props) => {
    const { t } = useTranslation();
    const { viewerSetting, linkBasicInfo, contents, errorCode, hasCustomFooter } = props.linkStore;
    const { isExpired, isCompliancePasswordRequired } = linkBasicInfo;

    const isMultiContent = contents.length > 1;
    const showLogo = isMobile() || (!isLargeDesktop() && isMultiContent);

    const viewerPanel = contents && <ViewerPanel
        key="ViewerPanel"
        isExpiredLink
        isOpen={props.openPanel}
        setOpenPanel={props.setOpenPanel}
        onSelectContent={props.onSelectContent} />;

    if (isExpired) {
        const isRequirePasswordInExpiredPage = (errorCode && errorCode !== ValidationErrorCode.LIVESEND_MANIFEST_OK) ||
            (isCompliancePasswordRequired && !getCompliancePwdCookie() && !props.validPasscode);

        try {
            if (!isCompliancePasswordRequired || isRequirePasswordInExpiredPage) {
                setNewrelicCustomAttribute('engagementviewer', 'expired page');
            }

            if (!isCompliancePasswordRequired) {
                return (<LinkExpired>
                    {viewerPanel}
                    {hasCustomFooter && <CustomFooter />}
                </LinkExpired>);
            }

            if (isRequirePasswordInExpiredPage) {
                return (
                    <div className="seismic-engagement-viewer-content">
                        <div className="seismic-engagement-viewer-compliance">
                            {showLogo && viewerSetting.logo && <img className="custom-logo" src={viewerSetting.logo} alt="logo" />}
                            <div className="-compliance">
                                <div className="-compliance-header">{t('LIVE_SEND_VIEWER_LINK_EXPIRED')}</div>
                                <div className="-compliance-message">{t('LIVE_SEND_VIEWER_CONTENT_EXPIRED_COMPLIANCE_MESSAGE')}</div>
                                <PasswordValidator
                                    source={PasswordSource.LINK_COMPLIANCE_PASSWORD}
                                    setPasswordValidation={props.setPasscodeValidation}
                                    placeholder={t('LIVE_SEND_VIEWER_COMPLIANCE_PWD_PLACEHOLDER')} />
                                <div className="-compliance-request-access">{t('LIVE_SEND_VIEWER_CONTENR_EXPIRED_REQUEST_ACCESS')}</div>
                            </div>
                        </div>
                        {viewerPanel}
                        {hasCustomFooter && <CustomFooter />}
                    </div>
                );
            }
        } finally {
            if (!isCompliancePasswordRequired || isRequirePasswordInExpiredPage) {
                executeNewrelicTracerForOthers();
            }
        }
    }

    return props.children;
};

export default withLinkStore(CompliancePage);
